export const PROD = true;

export let BASE_URL =
  PROD === true
    ? `https://school.notunkurifoundation.com`
    : `http://localhost:5004`;
